module.exports = __webpack_public_path__ + "c1f29973cb99d3442ab3f7189a339b7b.png";